import { post } from '@/api/core'

/**
 * 用户邀请码入群/围观
 * @description https://api.yinnho.cn/api.php?do=member_inv_code_join&help
 *
 * @param group_id 群id
 */
export function member_inv_code_join (follower_inv_code: string) {
  return post('member_inv_code_join', { follower_inv_code })
}
